import AudioCatalog from '@/components/audio-catalog';
import { Music } from 'lucide-react';

export default function MuziekPage() {
  return (
    <AudioCatalog
      contentType="music"
      contentNickname="Muziek & Frequenties"
      contentDescription="Ontspannende muziek en helende frequenties om je te ondersteunen bij meditatie, focus en diepe ontspanning."
      contentIcon={<Music className="h-8 w-8 text-green-500" />}
      pageKey="muziek"
    />
  );
}
